import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, Injectable, Injector, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { CommonApi, isErrorResponse } from '../core/api/common.api';
import { DialogService } from '../core/services/dialog.service';
import { ErrorMappingService } from '../core/services/error-mapping.service';
import { SnackBarService } from '../core/services/snack-bar.service';
import { FeatureFlagService } from '../app-load/services/feature-flag.service';
import * as Sentry from '@sentry/browser';
import { TranslateService } from '@ngx-translate/core';
@Injectable()
export class GlobalErrorHandler implements ErrorHandler {

  constructor(
    private injector: Injector,
    private dialogService: DialogService,
    private errorMappingService: ErrorMappingService,
    private snackBarService: SnackBarService,
    private featureFlagService: FeatureFlagService,

     ) { }
    // https://github.com/ngxs/store/issues/463
  handleError(error: Error ) {
    console.error( '[GlobalErrorHandler]' , error );
    this.dialogService.closeLoadingDialog( true );
    if ( this.featureFlagService.featureOn( 'sentry' ) ) {
      console.log( '[logging to sentry]' , error );
      Sentry.captureException( error );
    }
    if ( error instanceof HttpErrorResponse ) {
      if ( isErrorResponse( error ) ) {
        this.handleErrorResponse( <CommonApi.ErrorResponse>error );
        return;

      }
    } else {
      this.redirectToErrorPage();
    }
  }
  redirectToErrorPage() {
    const router = this.injector.get(Router);
    const zone = this.injector.get( NgZone );
    zone.run(() => router.navigate(['/system-error']));

  }

  handleErrorResponse( errorResponse: CommonApi.ErrorResponse) {

    if ( errorResponse.error.messages ) {
      const code: CommonApi.MessageCode = <CommonApi.MessageCode>errorResponse.error.messages[ 0 ].code;
      const showAsFlash = this.errorMappingService.showAsFlash( code );
      if ( showAsFlash ) {
        const message = this.errorMappingService.lookupMessage( code );
        if ( message == null ) {
          this.redirectToErrorPage();
          return;
        }
        this.snackBarService.flashError( message );
      }
    } else {
      this.redirectToErrorPage();
    }
  }
}

